import { useMemo } from 'react';

import { useMerchant } from '../contexts/MerchantContext';
import {
  getParentHierarchySaveBarCopy,
  type ParentHierarchySaveBarCopy,
} from '../util/parentSettingSave';

export function useParentHierarchySaveBarCopy(
  inheritableSettingLabels: string[],
  isSaving: boolean,
): ParentHierarchySaveBarCopy {
  const { hasDescendants } = useMerchant();

  return useMemo(
    () =>
      getParentHierarchySaveBarCopy(inheritableSettingLabels, {
        isSaving,
        hasDescendants,
      }),
    [hasDescendants, inheritableSettingLabels, isSaving],
  );
}
